<style src="./styles.scss" lang="scss"></style>
<template>
  <div class="guard-notification wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="mail-box">
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Setor</label>
            <div class="col-md-12">
              <select class="form-control" v-model="searchForm.park">
                <option value="">Todos</option>
                <option
                  v-for="(item, idx) in parkingList"
                  :key="idx"
                  :value="item.id"
                >
                  {{ item.parkName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Código</label>
            <input class="form-control" v-model="searchForm.creditCode" />
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Data Inicial</label>
            <input type="date" v-model.lazy="searchForm.dateStart"/>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Data Final</label>
            <input type="date" v-model.lazy="searchForm.dateEnd"/>
          </div>
        </div>
      </div>
      <div class="col-sm-1">
        <div class="form-group">
          <button
            @click="listGuardNotifications"
            type="submit"
            class="btn btn-block btn-primary compose-mail"
          >
            <i class="fa fa-search"></i>
            <i class="fa fa-spinner fa-spin" v-show="isExportSearchBusy"></i>
          </button>
        </div>
      </div>
      <div class="col-sm-1">
        <div class="form-group">
          <button
            @click="showConfirmSelectedExportModal"
            type="button"
            class="btn btn-block btn-warning compose-mail"
            :disabled="selectedItems.length === 0"
            title="Exportar Selecionados"
          >
            <i class="fa fa-database"></i>
            <i class="fa fa-spinner fa-spin" v-show="isExportSelectedBusy"></i>
          </button>
        </div>
      </div>
      <div class="col-sm-1">
        <div class="form-group">
          <button
            @click="showConfirmAllExportModal"
            type="button"
            class="btn btn-block btn-warning compose-mail"
            :disabled="isExportButtonDisabled"
            title="Exportar Todos"
          >
            <i class="fa fa-download"></i>
            <i class="fa fa-spinner fa-spin" v-show="isExportAllBusy"></i>
          </button>
        </div>
      </div>

      <div class="col-sm-1">
        <div class="form-group">
          <button
            @click="goToGuardConfig"
            type="submit"
            class="btn btn-block btn-grey compose-mail"
          >
            <i class="fa fa-cog"></i>
          </button>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="mail-box">
        <table class="table table-hover table-mail">
          <thead class="table-head">
            <tr>
              <th class="select"><input type="checkbox" v-model="doSelectAll"/></th>
              <th class="photo">Foto</th>
              <th class="code">Código</th>
              <th class="createdAt">Data do Registro</th>
              <th class="licencePlate">Placa</th>
              <th class="sector">Setor</th>
              <th class="amountPaid">Saldo Devedor</th>
              <th class="status">Status</th>
            </tr>
          </thead>

          <tbody class="table-list">
            <tr
              v-for="(item, itemIndex) in guardNotifications.list"
              :key="itemIndex"
              @click="selectItem(itemIndex)"
            >
              <td>
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="item.isSelected"
                />
              </td>
              <td class="photos">
                <button
                  class="photoButton"
                  @click.stop="openImage(photo)"
                  type="button"
                  v-for="(photo, photoIndex) in item.vehiclePhotoPath"
                  :key="photoIndex"
                >
                  <i class="fa fa-camera modal-icon"></i>
                </button>
              </td>
              <td>{{ item.creditCode }}</td>
              <td>{{ item.createdAt | DateBR }}</td>
              <td>{{ item.licencePlate.toUpperCase() }}</td>
              <td>[{{ item.parkCode }}] {{ item.parkName }}</td>
              <td>{{ item.amountPaid | totalToCurrencyBR }}</td>
              <td>
                <span class="badge" :class="`badge${item.status}`">
                  {{ item.status | Status }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="btn-group paginatecontent"
      v-if="guardNotifications.countPages > 0"
    >
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>
    <ModalExportAllConfirm
      :show="isExportAllModalVisible"
      @close-modal="closeConfirmAllExportModal"
      @confirm="exportAllNotifications"
      :total-documents="totalDocuments"
    />
    <ModalExportSelectedConfirm
      :show="isExportSelectedModalVisible"
      @close-modal="closeConfirmSelectedExportModal"
      @confirm="exportSelectedNotifications"
      :total-documents="countSelectedItems"
    />
  </div>
</template>
<script>
import { URI } from '../../../config/config';
import ModalExportAllConfirm from './modal-export-all-confirm/ModalExportAllConfirm.vue';
import ModalExportSelectedConfirm from './modal-export-selected-confirm/ModalExportSelectedConfirm.vue';

export default {
  components: {
    ModalExportAllConfirm,
    ModalExportSelectedConfirm
  },
  data() {
    return {
      isExportAllModalVisible: false,
      isExportSelectedModalVisible: false,
      isExportAllBusy: false,
      isExportSelectedBusy: false,
      isExportSearchBusy: false,
      totalDocuments: 0,
      doSelectAll: false,
      searchForm: {
        dateStart: 0,
        dateEnd: 0,
        creditCode: '',
        park: '',
        status: 1,
        page: 0,
        limit: 50,
      },
      guardNotifications: {
        countPages: 0,
        originalList: [],
        list: [],
      },
      parkingList: [],
    };
  },
  mounted() {
    this.setInitialDate();
    this.listGuardNotifications();
    this.listParkings();
  },
  computed: {
    isExportButtonDisabled() {
      return this.guardNotifications.list.length === 0 || this.isExportAllBusy || this.isExportSelectedBusy;
    },
    selectedItems() {
      return this.guardNotifications.list.filter(i => i.isSelected);
    },
    hasPageLeft() {
      return this.searchForm.page === 0;
    },
    hasPageRight() {
      return this.searchForm.page >= this.guardNotifications.countPages;
    },
    countSelectedItems() {
      const selected = this.guardNotifications.list.filter(
          item => item.isSelected,
        );
      return selected.length;
    }
  },
  filters: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
    Status(status) {
      switch (status) {
        case 0:
          return 'DISPONÍVEL';
        case 1:
          return 'PROCESSADO';
        case 2:
          return 'REMOVIDO';
      }
    },
  },
  watch: {
    doSelectAll(value) {
      this.guardNotifications.list.forEach(item => {
        item.isSelected = value;
      });
    },
  },
  methods: {
    setInitialDate() {
      this.searchForm.dateStart = new Date().toISOString().substr(0, 10);
      this.searchForm.dateEnd = new Date().toISOString().substr(0, 10);
      console.log(this.searchForm.dateStart)

    },
    goToGuardConfig() {
      this.$router.push({ name: 'GuardConfig' });
    },
    selectItem(itemIndex) {
      const isSelected = this.guardNotifications.list[itemIndex].isSelected;
      this.guardNotifications.list[itemIndex].isSelected = !isSelected;
    },
    openImage(photo) {
      let photoPath = photo.replace(
        '/var/app/server-user-manager/notify-photos/',
        '',
      );
      photoPath = photoPath.replace(
        '/var/app/server-manager/notify-photos/',
        '',
      );
      window.open(`${URI}${photoPath}`);
    },
    async listGuardNotifications() {
      if (!this.checkDateRange()) return;
      this.isExportSearchBusy = true;

      const dateStart = new Date(this.searchForm.dateStart + 'T03:00:00');
      const dateEnd = new Date(this.searchForm.dateEnd + 'T20:59:59');

      const payload = {
        ...this.searchForm,
        dateStart,
        dateEnd,
      };

      try {
        const guardNotifications = await this.$store.dispatch(
          'GUARD-REQUEST/ListGuardNotifications',
          payload,
        );

        const credits = guardNotifications.credits.map(i => ({
          ...i,
          isSelected: false,
        }));
        this.guardNotifications.list = credits;
        this.guardNotifications.countPages = guardNotifications.pages;
        this.totalDocuments = guardNotifications.totalDocuments;
      } catch (error) {
        this.$toasted.error('Não foi possível listar as solicitações');
      } finally {
        this.isExportSearchBusy = false;
      }
    },
    selectRequest(item) {
      this.$router.push({
        name: 'ManagerGuardRequestEdit',
        params: { requestId: item._id },
      });
    },
    createRequest() {
      this.$router.push({
        name: 'GuardCreateNotification',
      });
    },
    previousPage() {
      if (this.searchForm.page === 0) {
        return;
      }
      this.searchForm.page = this.searchForm.page - 1;
      this.listGuardNotifications();
    },
    nextPage() {
      if (this.searchForm.page + 1 >= this.guardNotifications.countPages) {
        return;
      }
      this.searchForm.page = this.searchForm.page + 1;
      this.listGuardNotifications();
    },
    async listParkings() {
      const parkingListFull = await this.$store.dispatch('PARKING/GetParkList');
      const parkingList = parkingListFull.map(item => ({
        id: item._id,
        parkName: item.parkName,
      }));
      this.parkingList = parkingList;
    },
    setDate(dt) {
      const date = new Date(dt);
      return date;
    },
    checkDateRange() {
      const isRangeValid = this.setDate(this.searchForm.dateStart) <= this.setDate(this.searchForm.dateEnd);
      if (!isRangeValid)this.$toasted.error('A data de início deve ser menor ou igual a data final');
      return isRangeValid;
    },
    async exportSelectedNotifications() {
      try {
        this.isExportSelectedBusy = true;

        const selected = this.guardNotifications.list.filter(
          item => item.isSelected,
        );
        const { fileName, fileContent } = await this.$store.dispatch(
          'GUARD-REQUEST/ExportDetranSP',
          selected,
        );
        const url = window.URL.createObjectURL(new Blob([fileContent]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        this.$toasted.success('Exportação concluída');
        await this.listGuardNotifications();
      } catch (error) {
        this.$toasted.error('Não foi possível exportar');
      } finally {
        this.isExportSelectedBusy = false;
        this.closeConfirmSelectedExportModal();
      }
    },
    async exportAllNotifications() {
      try {
        this.isExportAllBusy = true;

        const dateStart = new Date(new Date(this.searchForm.dateStart).setHours(0, 0, 0, 0));
        const dateEnd = new Date(new Date(this.searchForm.dateEnd).setHours(23, 59, 59, 999));

        const payload = {
          ...this.searchForm,
          dateStart,
          dateEnd,
        }
        const { fileName, fileContent } = await this.$store.dispatch(
          'GUARD-REQUEST/ExportAllDetranSP',
          payload,
        );
        const url = window.URL.createObjectURL(new Blob([fileContent]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        this.$toasted.success('Exportação concluída');
        await this.listGuardNotifications();
      } catch (error) {
        this.$toasted.error('Não foi possível exportar');
      } finally {
        this.isExportAllBusy = false;
        this.closeConfirmAllExportModal();
      }
    },
    async showConfirmAllExportModal() {
      if (!this.checkDateRange()) return;
      this.isExportAllModalVisible = true;
    },
    async showConfirmSelectedExportModal() {
      if (!this.checkDateRange()) return;
      this.isExportSelectedModalVisible = true;
    },
    closeConfirmAllExportModal() {
      this.isExportAllModalVisible = false;
    },
    closeConfirmSelectedExportModal() {
      this.isExportSelectedModalVisible = false;
    },
    confirmExport() {
      
    },
  },
};
</script>
